import ExamList from '@/components/exams/ExamList';

export default function ExamsPage() {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <ExamList />
        </div>
      </div>
    </div>
  );
}

